
import { ContentList } from "./components/ContentList";
import { AddContentCard } from "./components/AddContentCard";
import { useContentManagement } from "./hooks/useContentManagement";

export default function ContentManagement() {
  const {
    content,
    isLoading,
    newContent,
    submissionState,
    pagination,
    handleChangeContentCredits,
    handleTogglePremiereStatus,
    handleToggleContentVisibility,
    handleDeleteContent,
    handleAddContent,
    handleFileChange,
    handleThumbnailChange,
    handleContentChange,
    handlePageChange
  } = useContentManagement();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <ContentList
        content={content}
        isLoading={isLoading}
        onChangeCredits={handleChangeContentCredits}
        onToggleVisibility={handleToggleContentVisibility}
        onTogglePremiere={handleTogglePremiereStatus}
        onDeleteContent={handleDeleteContent}
        pagination={pagination}
        onPageChange={handlePageChange}
      />
      
      <AddContentCard
        newContent={newContent}
        onContentChange={handleContentChange}
        onFileChange={handleFileChange}
        onThumbnailChange={handleThumbnailChange}
        onAddContent={handleAddContent}
        submissionState={submissionState}
      />
    </div>
  );
}
